import React, {useState, useEffect} from 'react';
import {VisDiv, AddManualProduct } from '..';
import {useStateContext} from '../../context/StateContext';
import {sortByOrder, errorAlert  } from '../../lib/utils'; 
import Swal from "sweetalert2"
import { IoIosAddCircleOutline} from 'react-icons/io';
import {DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import useMediaQuery from '../../hooks/useMediaQuery';
import { generatedOfferDoc, generatedOfferWithTotalsDoc } from '../gestioneDatabase/Docs';
import { groupedOffer } from './GroupedOffer';
import { DraggablePin } from './DraggablePin';
import { GroupedHeader } from './GroupedPin';
import { ClientOrderPin } from './ClientOrderPin';
import { MdDragHandle } from "react-icons/md";
import TestButton from '../frontend_components/TestButton';
import { IoIosArchive } from "react-icons/io";

/**
 * A component that renders the customer products offer section of the report.
 * #
 * @param {Object} siteRegisters - The site registers data.
 * @param {Array} nonConformities - The non-conformities data.
 * @param {Array} allProducts - The all products data.
 * @param {Object} reportData - The report data.
 * @param {Object} register - The register data.
 * @param {Object} emptyDocGeneratedData - The empty doc generated data.
 * @param {Array} data - The data array.
 * @param {Array} dataGrouped - The data grouped array.
 * @param {Function} saveOffer - The save offer function.
 * @param {Object} offer - The offer data.
 * @param {Object} priceList - The price list data.
 * @param {Object} clientOrder - The client order data.
 */
const CustomerProductsOffer = ({siteRegisters, nonConformities=[], allProducts, reportData, register, emptyDocGeneratedData, data, dataGrouped, saveOffer, offer, priceList, clientOrder }) => {
    //const [offer, setOffer] = useState(importedOffer)

    //const [isEditingOffer, setIsEditingOffer] = useState(false)
    //console.log("IN CONSOLE CUSTOMER PRODUCTS", allProducts)
   
    const screenSizeDesktop = useMediaQuery("(min-width: 1540px)")
   
    const {setOffer, setIsEditingOffer, registerTemplates, LDB } = useStateContext()
    
    const addOrderToDataGroup = (array) => array?.map?.((item, index)=>{
      //console.log("sdhciuewhciuwehcf", array)
      const template = !Array.isArray(registerTemplates) ? undefined : registerTemplates?.find?.((x=>item?.registerTemplateId == x?._id))
   
      
      const order = () => {
        if(item?.order) return +item?.order
        if(item?.isSign && template)return template?.order
      
        
        //if(item?.customerProduct?.includes("REVISIONE")) return -0.1
        //if(item?.customerProduct?.includes("COLLAUDO")) return -0.2
        //if(item?.customerProduct?.includes("GESTIONE RIFIUTI")) return -0.4

        //if(item?.nonConformity?.includes("SOSTITUIRE PRESIDIO")) return -0.3
        //if(item?.nonConformity?.includes("FORNIRE PRESIDIO")) return -0.5

        return index
      }
      const doc = {...item, descriptionText: item?.description?.blocks?.map?.((x)=>x?.text)?.toString(), order: order()}
      //if(item?.nonConformity?.includes("SOSTITUIRE PRESIDIO")) {console.log("IN CONSOLE IN ORDER", doc)}
      return doc
    })
    

    
  
    const [dataArray, updateDataArray] = useState(addOrderToDataGroup(data)?.sort(sortByOrder));
    const dataOffer = dataArray?.map?.((x)=>generatedOfferDoc(x))
    const dataWithTotals = !Array.isArray(dataOffer) ? [] : dataOffer?.map?.((x)=>generatedOfferWithTotalsDoc(x))
    const grouped = groupedOffer(dataWithTotals)
    const [draggableArray, updateDraggableArray] = useState(addOrderToDataGroup(grouped)?.sort(sortByOrder));
    
    const [isAdding, setIsAdding] = useState(false)

    // REPORT AND OFFER EQUALITY

    const consoleData = {
        reportData: reportData,
        //dataGrouped: dataGrouped,
        offerFields: ! Array.isArray(offer?.offerFields) ? [] : offer?.offerFields,
        siteRegisters,
        dataArray,
      }
  
    const updatedOffer = (data)=>{
      console.log("WOW!! UPDATE OFFER TO SAVE OFFER", {data})
      //setOffer(data)
      saveOffer(data)
    }


    function handleOnDragEnd(result) {
   
      if (!result.destination) return;
      //changed, it was Array.from(draggableArray), but it was not updating when adding new positions. 
      const items = Array.from(groupedOffer(dataArray));
      //console.log("ITEMS: ", items)

      const [reorderedItem] = items.splice(result.source.index, 1);
      items.splice(result.destination.index, 0, reorderedItem);  
      //console.log("items 2", items)

      const newOrderArray = items?.map?.((item, index)=>({...item, order: index}))

      //console.log("newOrderArray: ", newOrderArray)

      const updatedProducts = (groupedItem) => {
          const fieldsIds = groupedItem?.fieldsIds ? groupedItem?.fieldsIds : []
          const products = fieldsIds?.map?.((id)=> {
            const product = !Array.isArray(dataArray) ? undefined : dataArray?.find?.((x)=>x?._id == id)
            const newOrderProduct = !product ? {} : {...product, order: groupedItem?.order} 
            return newOrderProduct
          })
          return products
      } 
      const updatedDataArray = () => {
        return !Array.isArray(newOrderArray) ? [] : newOrderArray?.map?.((item) => updatedProducts(item))
      }
      const newDataArray = updatedDataArray()?.flat() 

      //console.log("DRAG RESULT: ", newDataArray, "DATA ARRAY", dataArray, "NEW DATA ARRAY")
      updateDraggableArray(!Array.isArray(newOrderArray) ? [] : newOrderArray?.filter?.(x=>x));
      updatedOffer({...offer, offerFields:[...!Array.isArray(offer?.offerFields) ? [] : offer?.offerFields?.filter?.((x)=>!newDataArray?.some?.((y)=>x?._id == y?._id)), ...newDataArray]})
      updateDataArray(newDataArray)
      
      //setIsEditingOffer(true)

    }
    //columnMinWidth = "85px"
    const commonStyle = (edit) => { 
      
      return (
      {
        display:"flex", 
        alignItems:"center", 
        fontSize:"12px", 
        justifyContent:"center", 
        width: edit ? "160px":"85px", 
        minWidth: edit ? "160px":"85px", 
        padding: "20px", 
        borderRight: 1, 
        borderRightColor: "#d1c5c5", 
        borderRightStyle: "dotted" 
      }
        )}
        const offerField = dataArray?.[0]

        const saveNewManualDoc = (data) => {
          
          //setIsEditingOffer(true)

          // CREATE NEW ITEM TO ADD TO TOP OF DRAGGABLE ARRAY
          const checkExistingDescription = !Array.isArray(dataArray) ? false : dataArray?.some?.((x)=>x?.descriptionText == data?.[0]?.descriptionText)
          if (checkExistingDescription) {
            errorAlert("ESISTE GIA' UN PRODOTTO CON QUESTA DESCRIZIONE, CAMBIARE DESCRIZIONE E RIPROVARE")
            return
          }
          const dataOffer = data?.map?.((x)=>generatedOfferDoc(x))
          const dataWithTotals = !Array.isArray(dataOffer) ? [] : dataOffer?.map?.((x)=>generatedOfferWithTotalsDoc(x))
          const grouped = groupedOffer(dataWithTotals)
          console.log("newManualDocs",{
            data, dataOffer, dataWithTotals, dataArray 
          })
          updateDraggableArray([...grouped, ...!Array.isArray(draggableArray) ? [] : draggableArray])
          updateDataArray([...dataWithTotals, ...!Array.isArray(dataArray) ? [] : dataArray])
          updatedOffer({...offer, offerFields:[...!Array.isArray(offer?.offerFields) ? [] : offer?.offerFields, ...dataOffer]})
          setIsAdding(false)
        }

        const addNewLine = () => {
          setIsAdding(true)
          console.log("LINE:", offer, )
        }

        
  return (
    <VisDiv>

      <VisDiv rules={[draggableArray?.length>0]}>
        <GroupedHeader commonStyle={commonStyle}/>
        <TestButton buttonId='kljlkqjlwej' message='data Customer Products Offer' consoleData={consoleData} />
      </VisDiv>
      <VisDiv rules={[clientOrder]}>
        {draggableArray?.map?.((item, index)=>{
          return(
            <ClientOrderPin
              key={index}
              register={register}
              item={item}
              index={index}
              updatedOffer={updatedOffer}
              updateDataArray={updateDataArray}      
              dataArray = {dataArray}
              offer = {offer}
              commonStyle= {commonStyle}
              setIsEditingOffer = {setIsEditingOffer}
              clientOrder = {clientOrder}
          />
          )
        })}
      </VisDiv>
      <VisDiv rules={[!clientOrder]}>
        <VisDiv style={{color:"darkBlue", cursor:"pointer", marginLeft:"10px", marginTop:"10px"}} >
            <VisDiv rules={[!isAdding]} className='round-back-button' style={{backgroundColor:"white"}} onClick={(e) => {addNewLine()}}> 
              <IoIosAddCircleOutline fontSize={30} />
            </VisDiv>
            <VisDiv rules={[isAdding]}>
              <AddManualProduct 
                saveFn={saveNewManualDoc} 
                commonStyle={commonStyle} 
                data={{
                  priceList, 
                  nonConformities, 
                  emptyDocGeneratedData, 
                  offerField, 
                  draggableArray, 
                  register, 
                  registerTemplate: !Array.isArray(registerTemplates) ? undefined : registerTemplates?.find?.((x=>register?.template?._ref == x?._id)), 
                  allProducts, 
                  siteRegisters, 
                  setIsAdding
                  }} />
            </VisDiv>
        </VisDiv>
        <DragDropContext onDragEnd={handleOnDragEnd}>
          <Droppable droppableId="draggableArray">
            {(provided) => (
              <ul className="draggableArray" {...provided.droppableProps} ref={provided.innerRef}>
                {draggableArray?.map?.((item, index) => {
                  
                  const findCustomerProduct = allProducts?.customerProducts?.find((x)=>x?._id == item?.customerProductId)
                  const isCustomerProductArchived = findCustomerProduct?.status == "ARCHIVIATO"
                  const archivedBackground = !isCustomerProductArchived ? {} : {backgroundColor:"lightYellow"}
                  const onRowClick = () => {
                    const findInOffer = !Array.isArray(offer?.offerFields) ? undefined : offer?.offerFields?.find?.((x)=>item?.fieldsIds?.includes?.(x?._id))
                    const findInDataArray = !Array.isArray(dataArray) ? undefined : dataArray?.find?.((x)=>item?.fieldsIds?.includes?.(x?._id))
                    console.log("CLICKED ROW DRAGGABLE ITEM lqkwslkwqsj", { 
                      findInOffer, 
                      findInDataArray,
                      item: item, 
                      draggableArray, 
                      offerFieldsInItem: offer?.offerFields?.filter?.((x)=>item?.fieldsIds?.includes?.(x?._id)),
                      offerFields: offer?.offerFields?.filter?.((x)=>x?._id),
                      findCustomerProduct
                    })
                    
                  }
                  return (
                    <Draggable key={item?._key} draggableId={item?._id} index={index}>
                      {(provided) => (
                        <div  onClick={onRowClick} ref={provided.innerRef} {...provided.draggableProps}>
                            <div  {...provided.dragHandleProps} style={{...archivedBackground, display:"flex", marginTop:"10px", justifyContent:"center", alignItems:"center", height:"34px", border:"1px solid #ccc"}}>
                              <VisDiv rules={[!isCustomerProductArchived]}>
                                <MdDragHandle color={"#ccc"} size={25} />
                              </VisDiv>
                              <VisDiv rules={[isCustomerProductArchived]}>
                                <IoIosArchive color={"lightGrey"} size={28} />
                              </VisDiv>
                            </div>
                            <DraggablePin
                              register={register}
                              registerTemplate ={!Array.isArray(registerTemplates) ? undefined : registerTemplates?.find?.((x=>item?.registerTemplateId == x?._id))}
                              nonConformities={nonConformities}
                              item={item}
                              index={index}
                              updatedOffer={updatedOffer}
                              updateDataArray={updateDataArray} 
                              priceListItem = {priceList?.products?.find?.((x)=>x?.customerProduct?._ref == item?.customerProductId)}
                              dataArray = {dataArray}
                              offer = {offer}
                              commonStyle= {commonStyle}
                              setIsEditingOffer = {setIsEditingOffer}
                        
                            />
                        </div>
                      )}
                    </Draggable>
                  );
                }
              
              )}
                {provided.placeholder}
              </ul>
            )}
          </Droppable>
        </DragDropContext>
      </VisDiv>
    </VisDiv>
  )
}


export default CustomerProductsOffer

//==============


export const alertDelete = (fn, LDB, type) => {
  const text = () => {

      return ({
          title: "Vuoi eliminare questa riga?",
          confirm:  "sì",
          deny: "no, annulla",
      })
  }
  Swal.fire({
      title: text()?.title,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: text()?.confirm,
      cancelButtonText: text()?.deny,
    }).then((result) => {
      if (result.isConfirmed) {
          fn()
      }
    })
}